export enum ReportViewType {
  NORMAL = "normal",
  FULLSCREEN_DASHBOARD = "fullScreen_dashboard",
  FULLSCREEN = "fullScreen",
  PREVIEW = "preview"
}

export type ExportToPngPdfPpt = "PNG" | "PDF" | "PPT";
